module.exports = __webpack_public_path__ + "static/media/loan-details.3e63d3c3.png";